import { render, staticRenderFns } from "./ProductHistory.vue?vue&type=template&id=76bd3954&"
import script from "./ProductHistory.vue?vue&type=script&lang=js&"
export * from "./ProductHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports